import { Type } from '@angular/core';
import { formatNumber } from '@angular/common';

import { AbstractFilterTypeComponent } from './abstract-filter-type.component';
import { CustomFilterTypeModel } from './custom-filter-type.model';
import { FilterTypesEnum } from '../enums/filters-types.enum';
import { NetworkTypeEnum } from '../../../Social/Core/enums/network-type.enum';
import { RangeModel } from './range.model';
import { ChipModel } from '../../Forms/models/chip.model';

export interface EngagementFilterApiModel {
    engagementRate: RangeModel;
    engagementTotal: RangeModel;
    amplification?: RangeModel;
    conversation?: RangeModel;
    applause?: RangeModel;
    view?: RangeModel;
}

export const engagementFilterApiKeys: (keyof EngagementFilterApiModel)[] = [
    'engagementRate',
    'engagementTotal',
    'amplification',
    'conversation',
    'applause',
    'view'
];

export type EngagementFilterValueModel = Required<Omit<EngagementFilterApiModel, 'engagementRate'>>;

export const engagementFilterKeys: (keyof EngagementFilterValueModel)[] = [
    'engagementTotal',
    'amplification',
    'conversation',
    'applause',
    'view'
];

export interface EngagementChipLabelArgs {
    key: keyof EngagementFilterValueModel;
    name: string;
    min?: string;
    max?: string;
}

export interface NetworkType {
    networkType: NetworkTypeEnum;
    label: string;
    expanded: boolean;
    engagementTypes: EngagementType[];
}

export interface EngagementType {
    label: string;
    expanded: boolean;
    range: RangeModel;
}
export class EngagementFilterModel extends CustomFilterTypeModel<EngagementFilterValueModel> {

    readonly key: FilterTypesEnum = FilterTypesEnum.custom;

    value: EngagementFilterValueModel;
    currentValue: EngagementFilterValueModel;

    constructor(
        id: string,
        label: string,
        component: Type<AbstractFilterTypeComponent>,
        section?: string
    ) {
        super(id, label, component, section);

        this.clear();
    }

    static createBlankFilter(): EngagementFilterValueModel {
        return {
            engagementTotal: { min: NaN, max: NaN },
            amplification: { min: NaN, max: NaN },
            conversation: { min: NaN, max: NaN },
            applause: { min: NaN, max: NaN },
            view: { min: NaN, max: NaN },
            // @TODO NEP-11189
            // networkTypes: [
            //     {
            //         label: `MediaType.${MediaTypeEnum.TWITTER}`,
            //         expanded: false,
            //         networkType: NetworkTypeEnum.twitter,
            //         engagementTypes: [
            //             {
            //                 label: 'Social.filter.engagements.twitter.retweets',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.twitter.quoteTweets',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.twitter.replies',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.favorites',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             }
            //         ]
            //     },
            //     {
            //         label: `MediaType.${MediaTypeEnum.FACEBOOK}`,
            //         expanded: false,
            //         networkType: NetworkTypeEnum.facebook,
            //         engagementTypes: [
            //             {
            //                 label: 'Social.filter.engagements.shares',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.comments',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.likes',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.reactions',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             }
            //         ]
            //     },
            //     {
            //         label: `MediaType.${MediaTypeEnum.INSTAGRAM}`,
            //         expanded: false,
            //         networkType: NetworkTypeEnum.instagram,
            //         engagementTypes: [
            //             {
            //                 label: 'Social.filter.engagements.shares',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.comments',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.likes',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             }
            //         ]
            //     },
            //     {
            //         label: `MediaType.${MediaTypeEnum.YOUTUBE}`,
            //         expanded: false,
            //         networkType: NetworkTypeEnum.youtube,
            //         engagementTypes: [
            //             {
            //                 label: 'Social.filter.engagements.shares',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.comments',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.likes',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.views',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             }
            //         ]
            //     },
            //     {
            //         label: `MediaType.${MediaTypeEnum.REDDIT}`,
            //         expanded: false,
            //         networkType: NetworkTypeEnum.reddit,
            //         engagementTypes: [
            //             {
            //                 label: 'Social.filter.engagements.shares',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.comments',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.reddit.upvotes',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.reddit.downvotes',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             },
            //             {
            //                 label: 'Social.filter.engagements.reddit.awards',
            //                 expanded: false,
            //                 range: <RangeModel>{ min: NaN, max: NaN }
            //             }
            //         ]
            //     }
            // ]
        };
    }

    private constructChips(value: EngagementFilterValueModel): ChipModel[] {
        const chips: ChipModel[] = Object.entries(value).map(([k, v]) => this.makeChip(k, v.min, v.max));

        // @TODO NEP-11189
        // value.networkTypes.forEach(network => {
        //     network.engagementTypes.forEach(type => {
        //         if (type.range?.min || type.range?.max) {
        //             const chipLabel = `${this.localizationService.transform(network.label)} ${this.localizationService.transform(type.label)}`;
        //             chips.push(this.makeChip(chipLabel, type.range.min, type.range.max));
        //         } else {
        //             type.range = <RangeModel>{ min: NaN, max: NaN };
        //         }
        //     });
        // });

        return chips.filter(chip => !!chip);
    }


    makeChip(key: string, min: number, max: number): ChipModel {
        if (min && max) {
            return <ChipModel>{
                label: 'Common.filter.range.minToMax',
                labelArgs: {
                    key,
                    name: `Social.filter.engagements.${key}`,
                    min: formatNumber(min, 'en'),
                    max: formatNumber(max, 'en')
                } as EngagementChipLabelArgs
            };
        } else if (min) {
            return <ChipModel>{
                label: 'Common.filter.range.greaterThan',
                labelArgs: {
                    key,
                    name: `Social.filter.engagements.${key}`,
                    min: formatNumber(min, 'en')
                } as EngagementChipLabelArgs
            };
        }  else if (max) {
            return <ChipModel>{
                label: 'Common.filter.range.lessThan',
                labelArgs: {
                    key,
                    name: `Social.filter.engagements.${key}`,
                    max: formatNumber(max, 'en')
                } as EngagementChipLabelArgs
            };
        } else {
            return null;
        }
    }

    setCurrentValue(value: EngagementFilterValueModel) {
        this.currentValue = value;
        const chips = this.constructChips(this.currentValue);
        this.currentChips = [...chips];
    }

    getCurrentValue(): EngagementFilterValueModel {
        return this.currentValue;
    }

    removeCurrentChip(chip: ChipModel) {
        const { key } = chip.labelArgs as EngagementChipLabelArgs;
        if (key) {
            this.currentValue[key] = { min: NaN, max: NaN } as RangeModel;
            this.setCurrentValue(this.currentValue);
        }
    }

    hasValues(): boolean {
        // @TODO NEP-11189
        // this.value.networkTypes?.forEach(network => {
        //     network.engagementTypes?.forEach(engagementType => {
        //         if (engagementType.range?.min || engagementType.range?.max) {
        //             engagementHasValues = true;
        //         }
        //     });
        // });

        return Object.values(this.value).reduce(
            (pre, value) => !isNaN(value.min) || !isNaN(value.max) || pre,
            false
        );
    }

    setValue(value: EngagementFilterValueModel) {
        this.value = value;
        const chips = this.constructChips(this.value);
        this.chips = [...chips];
        this.cancelChanges();
    }

    getValue(): EngagementFilterValueModel {
        return this.value;
    }

    removeChip(chip: ChipModel): void {
        const { key } = chip.labelArgs as EngagementChipLabelArgs;
        if (key) {
            this.value[key] = { min: NaN, max: NaN };
            this.setValue(this.value);
        }
    }

    clear() {
        const defaultValue = EngagementFilterModel.createBlankFilter();
        this.setValue(defaultValue);
    }

    cancelChanges() {
        this.setCurrentValue(this.value);
    }
}
